"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Td = exports.Th = exports.Tr = exports.Thead = exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n  color: black;\n  padding: 10px 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  color: black;\n  padding: 10px 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  border: solid ", ";\n  border-width: 1px 0;\n\n  &:first-child {\n    border-top: none;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  font-weight: 600;\n\n  & tr {\n    border-bottom: none;\n  }\n\n  & td {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Thead = _styledComponents.default.thead.withConfig({
  displayName: "Table__Thead",
  componentId: "sc-1h2np9n-0"
})(_templateObject(), function (props) {
  return props.theme["$gray-50"];
});

exports.Thead = Thead;

var Tr = _styledComponents.default.tr.withConfig({
  displayName: "Table__Tr",
  componentId: "sc-1h2np9n-1"
})(_templateObject2(), function (props) {
  return props.theme["$gray-10"];
});

exports.Tr = Tr;

var Th = _styledComponents.default.th.withConfig({
  displayName: "Table__Th",
  componentId: "sc-1h2np9n-2"
})(_templateObject3());

exports.Th = Th;

var Td = _styledComponents.default.td.withConfig({
  displayName: "Table__Td",
  componentId: "sc-1h2np9n-3"
})(_templateObject4());

exports.Td = Td;

var Table = function Table(_ref) {
  var headers = _ref.headers,
      rows = _ref.rows,
      children = _ref.children;

  if (headers && rows) {
    return _react.default.createElement("table", null, _react.default.createElement(Thead, null, _react.default.createElement(Tr, null, headers.map(function (header, i) {
      return _react.default.createElement(Th, {
        key: i
      }, header.label);
    }))), _react.default.createElement("tbody", null, rows.map(function (row, j) {
      return _react.default.createElement(Tr, {
        key: j
      }, headers.map(function (header, i) {
        return _react.default.createElement(Td, {
          key: i
        }, row[header.key]);
      }));
    })));
  } else {
    return _react.default.createElement("table", null, children);
  }
};

Table.displayName = "Table";
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table"
};
var _default = Table;
exports.default = _default;
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table"
};